import {Subscription} from 'rxjs';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common'
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatBadgeModule } from '@angular/material/badge';
import { WebService, lastValueFrom, RealtimeService, NavTabService } from '@services';

@Component({
  selector: 'app-notifications',
  imports: [MatIconModule, MatMenuModule, MatButtonModule, MatBadgeModule, CommonModule],
  templateUrl: './notifications.component.html',
  styleUrl: './notifications.component.scss'
})
export class NotificationsComponent implements OnInit, OnDestroy {

  private subscription?:Subscription;
  private bellTimer?:ReturnType<typeof setTimeout>;
  Notifications: any[] = [];
  UnreadCount = 0;
  RingBell = false;

  constructor(private web: WebService, private rts: RealtimeService,private tabs:NavTabService) { }

  async ngOnInit() {
    await this.GetNotifications();

    // 🔔 When a notification comes in, refresh & animate the bell
    this.subscription=this.rts.notificationAdded$.subscribe(async (payload) => {
      if (!payload) return;
      console.log(payload);
      const myGuid = (localStorage['GUID'] || '').toLowerCase();

      const list = Array.isArray(payload) ? payload : [payload];

      const hasMine = list.some(n =>
        (n.TraderGUID || '').toLowerCase() === myGuid
      );

      if (!hasMine && !payload.refresh) return;
      const previous=this.UnreadCount;

      await this.GetNotifications();
      if(this.UnreadCount>previous)this.TriggerBellAnimation();
    });
  }

  async GetNotifications() {
    this.Notifications = await lastValueFrom(
      this.web.getWebCall('notification', 'notifications', {
        params: [{ value: localStorage['GUID'], name: 'UserID' }],
        skipLoader: true
      })
    );

    this.UnreadCount = this.Notifications.filter(n => !n.NotificationRead).length;
  }

  TriggerBellAnimation() {
    this.RingBell = true;
    clearTimeout(this.bellTimer);
    this.bellTimer=setTimeout(() => this.RingBell = false, 3000); // rings for 3 seconds
  }
  ngOnDestroy(){this.subscription?.unsubscribe();clearTimeout(this.bellTimer);}
  openNotification(n:any){
    if(n.EntityType==='rts-ticket' && Number(n.EntityID)>0)this.tabs.addTab({title:'My Tickets',icon:'confirmation_number',componentKey:'rtsTickets',data:{TicketID:Number(n.EntityID)}});
    if(n.EntityType==='purchase-order' && Number(n.EntityID)>0)this.tabs.addTab({title:'Purchase Orders',icon:'shopping_basket',componentKey:'purchaseOrders',data:{PurchaseOrderID:Number(n.EntityID)}});
  }
  async DeleteNotification(notification: any) {
    await lastValueFrom(this.web.getWebCall('notification', '/notification/delete', { params: [{ value: notification.NotificationID, name: 'NotificationID' }] }))
    this.GetNotifications();
  }
}
